<script>

import DrawerAside from "../../package/DrawerAside.vue";
import HeaderSection from "../../package/HeaderSection.vue";
import FooterSection from "../../package/footerSection.vue";
import EmailUsSectionLight from "../../contact/emailUsSectionLight.vue";
import agentSignInSection from "../../package/agentSignInSection.vue";
import RequestAgentKitDialog from "../../common/requestAgentKitDialog.vue";
// import MobileAppDownload from "../../package/mobileAppDownload.vue";
import { redirectToAgentLogin } from "../../../helpers/routerHelper";
import AgentRegistrationSection1 from "./agentRegistrationSection1.vue";
import AgentRegistrationSection4 from "./agentRegistrationSection4.vue";
import AgentRegistrationSection3 from "./agentRegistrationSection3.vue";
import AgentRegistrationSection2 from "./agentRegistrationSection2.vue";
import VideoPlayWidget from "../../common/videoPlayWidget.vue";

export default {
  name: "agentRegistrationLayout",
  data() {
    return {
      unfold: false,
      requestAgentDialogVisible: false,
      videoUrl :"https://s3.ap-southeast-2.amazonaws.com/com.unifiproperty/unifi-video/for-Agents-loop.mp4",
      videoType: "video/mp4"
    };
  },
  components: {
    AgentRegistrationSection4, AgentRegistrationSection3, AgentRegistrationSection2, VideoPlayWidget,
    AgentRegistrationSection1,
    EmailUsSectionLight,
    FooterSection,
    HeaderSection, DrawerAside, agentSignInSection, RequestAgentKitDialog,
    // MobileAppDownload,
},
  beforeUpdate() {
    document.title = "UNIFI Property: Agent";
  },
  created() {
    document.title = "UNIFI Property: Agent";
  },
  mounted() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    let color = this.value1 ? "#2D2D2D" : "#FFFFFF";
    document.documentElement.style.setProperty("--switch-color", color);
  },
  watch: {
    value1(newValue) {
      let color = newValue ? "#2D2D2D" : "#FFFFFF";
      document.documentElement.style.setProperty("--switch-color", color);
    }
  },
  methods: {
    redirectToAgentLogin,
    requestAgentKit() {
      this.requestAgentDialogVisible = true;
    },
    spread() {
      this.unfold = true;
    },
    fold() {
      this.unfold = false;
      console.log("this.unfold = false");
    }
  }
}
</script>

<template>

  <el-container class="mainWrapper">
    <el-aside style="padding: 0;" width="0vw">
      <drawer-aside :unfold="unfold" @unfoldMethod="fold($event)" />
    </el-aside>
    <el-container>
      <header-section @spread="spread" />
      <el-main style="padding: 0; overflow: visible;">

        <agent-registration-section1/>
        <video-play-widget :video-url="videoUrl" :video-type="videoType"/>
        <agent-registration-section2/>
        <agent-registration-section3/>
        <agent-registration-section4/>

        <email-us-section-light />
<!--        <mobile-app-download />-->
    </el-main>
      <el-footer style="padding: 0; height: 0">
        <footer-section />
      </el-footer>
    </el-container>
  </el-container>
</template>

<style scoped>
.mainWrapper {
  background-color: #ffffff;
}
</style>



// WEBPACK FOOTER //
// src/components/register/agentRegistration/agentRegistrationLayout.vue